import {
  CModal,
  CModalBody,
  CModalFooter,
  CFormLabel,
  CFormInput,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CModalHeader,
  CModalTitle,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormTextarea,
  CAccordion,
  CAccordionHeader,
  CAccordionItem,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CAccordionBody,
  CTable,
} from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import PatientInfo from './PatientInfo.jsx'
import './Patient.css'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Select from 'react-select'
import AddPatientForm from './AddNewPatient'
import SavePatients from '../../services/general/savePatientinformation.api'
import InsuranceTab from './InsuaranceTab.jsx'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api.js'
import EditIcon from '@material-ui/icons/Edit'
import VisibilityIcon from '@material-ui/icons/Visibility'
import DeleteIcon from '@material-ui/icons/Delete'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import Pageloader from '../../components/shared/Pageloader.jsx'
import PatientPopup from './PatientPopup.jsx'
import SaveExtra from '../../services/general/saveExtraData.api.js'
import { motion } from 'framer-motion'
import { AlignLeft, CalendarCheck, EllipsisVertical, Eye, Table2, TrainFrontTunnel, X } from 'lucide-react'
import { FunnelPlotOutlined } from '@ant-design/icons'
import PatientNoteDataCRUD from '../../../src/services/general/patientNoteData.api.js'
import toast from 'react-hot-toast'
import { toastConfig } from '../../../src/constants/other.config.js'
import { patientMatchesSearch } from '../../utils/searchUtils'
import { HiExclamationCircle, HiEye, HiPencil } from 'react-icons/hi'
import { Schedule } from '@mui/icons-material'
import PatientSuperBillData from '../../services/general/patientSuperBill.api.js'
import PatientProviderPatientInfo from './PatientProviderPatientInfo.jsx'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
import ProviderPatientPoupSignedChart from './ProviderPatientPoupSignedChart.jsx'
import PatientAppointmentDetails from '../../services/general/appointmentData.api.js'
import { useSidebar } from '../../components/SidebarContext.jsx'
import { getAllAppointmentsDetails } from '../../components/shared/appointmentFilterData.jsx'
import { getFacilityParentCompany, getPatientFacilityParentCompany } from '../../utils/facilityParentCompany'
import { useIndexedDB } from '../../context/IndexedContext.jsx'

const CompletedProviderAppointment = () => {
  const [patientIDClicked, setPatientIDClicked] = useState(-1)
  const [rowClicked, setRowClicked] = useState(null)
  const [selectedFacility, setSelectedFacility] = useState({})
  const [roomNumber, setRoomNumber] = useState('')
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [addedInsurances, setAddedInsurances] = useState([])
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const [insuranceList, setInsuranceList] = useState([])
  const [showNoteJustThisId, setShowNoteJustThisId] = useState(null)
  const [boxView, setBoxView] = useState('list')
  const [patientInfoCount, setPatientInfoCount] = useState({
    followUp: 0,
    newPatient: 0,
  })
  const { isSidebarOpen, toggleSidebar, closeSidebar, openSidebar } = useSidebar()

  useEffect(() => {
    // if sidebar is not showing on page render then show
    if (!isSidebarOpen) {
      openSidebar()
    }
  }, [])

  const [selectedDetails, setSelectedDetails] = useState({})
  const [activeTab, setActiveTab] = useState('patientDetails')
  const buttonList = [{ Name: 'View' }, { Name: 'Edit' }, { Name: 'Delete' }]
  const [patientID, setPatientID] = useState('')
  const [allPatientVisible, setAllPatientVisible] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  var selectedDiagnosis = []
  const [allSelectedDiagnosis, setAllSelectedDiagnosis] = useState([])
  const [facilities, setFacilities] = useState([])
  const [patientData, setPatientData] = useState('')
  const [patientCount, setPatientCount] = useState(-1)
  const [viewPatientDetail, setViewPatientDetail] = useState()
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [patientModelVisible, setPatientModalVisible] = useState(false)
  const [dataCallType, setDataCallType] = useState(null)
  const [setDataId, setEditDataId] = useState(null)
  const [showPatientInfo, setShowPatientInfo] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deletePatientID, setDeletePatientID] = useState(null)
  const [appointment, setAppointment] = useState([])
  const [appointmentPatient, setAppointmentPatient] = useState(null)
  const [appointments, setAppointments] = useState([])
  const [noteID, setNoteID] = useState(null)
  const [cancelModel, setCancelModel] = useState(false)
  const [finishModel, setFinishModel] = useState(false)
  const [appointmentDataID, setAppointmentDataID] = useState(null)
  const [appointmentID, setAppointmentID] = useState(null)
  const [allAppointment, setAllAppointment] = useState([])
  const [noteStatus, setNoteStatus] = useState('New Note')
  const [patientAppointmentID, setPatientAppointmentID] = useState(null)
  const [patientId, setPatientId] = useState(null)
  const [creatingNewNote, setCreatingNewNote] = useState(false)
  const [superBill, setSuperBill] = useState([])
  const [scheduleTime, setScheduleTime] = useState(null)
  const [deleteModel, setDeleteModel] = useState(false)
  const [loaderAppointment, setLoaderAppointment] = useState(null)
  const [childformData, setChildFormData] = useState({
    FirstName: '',
    MiddleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Age: '0',
    PhoneNumber: '',
    EmergencyName: '',
    EmergencyPhone: '',
    Address: '',
    State: '',
    City: '',
    ZipCode: '',
    Country: '',
    insurance: '',
  })

  const resetStates = () => {
    setChildFormData({
      FirstName: '',
      MiddleName: '',
      LastName: '',
      DOB: '',
      Gender: '',
      Age: '0',
      PhoneNumber: '',
      EmergencyName: '',
      EmergencyPhone: '',
      Address: '',
      State: '',
      City: '',
      ZipCode: '',
      Country: '',
      insurance: '',
    })
    setRoomNumber('')
    setSelectedFacility({})
    setAddedInsurances([])
    setInsuranceList([])
    setSelectedDetails({})
    setAllSelectedDiagnosis([])
    setModalVisible(false)
  }

  const [daysMap, setDaysMap] = useState({})
  const [locations, setLocations] = useState([])
  const [cancelReason, setCancelReason] = useState('')
  const [noteId, setNodeId] = useState(null)
  const [noteIndex, setNoteIndex] = useState(false)
  const [showNotePatient, setShowNotePatient] = useState(false)

  const patientSelected = async (rowSelected) => {
    getData()
    setViewPatientDetail(rowSelected)

    let patientInsurance = await PatientInsuranceFn('SELECTALL', '', rowSelected.PatientID)

    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
    } catch (e) {}

    try {
      let tempSelectedDiagnosis = rowSelected.Diagnosis ? rowSelected.Diagnosis.split(',') : []
      selectedDiagnosis = diagnosisData.filter((obj) => tempSelectedDiagnosis.includes(obj.label))
      setRoomNumber(rowSelected?.Room)
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      setSelectedFacility(userFacilities ? userFacilities : facilities[0])
      setAllSelectedDiagnosis(selectedDiagnosis)
    } catch (e) {
      setAllSelectedDiagnosis([])
    }

    setChildFormData({
      FirstName: rowSelected.FirstName || '',
      MiddleName: rowSelected.MiddleName || '',
      LastName: rowSelected.LastName || '',
      DOB: rowSelected.DOB || '',
      Gender: rowSelected.Gender || '',
      Age: rowSelected.Age || '0',
      PhoneNumber: rowSelected.PhoneNumber || '',
      EmergencyName: rowSelected.EmergencyName || '',
      EmergencyPhone: rowSelected.EmergencyPhone || '',
      Address: rowSelected.Address || '',
      State: rowSelected.State || '',
      City: rowSelected.City || '',
      ZipCode: rowSelected.ZipCode || '',
      Country: rowSelected.Country || '',
    })

    setSelectedDetails({ Insurances: patientInsurance })
  }

  const openTreatmentNote = (rowSelected, appointmentID) => {
    setPatientID(rowSelected?.PatientID)
    setPatientIDClicked(rowSelected?.PatientID)
    setRowClicked(rowSelected)
    setPatientModalVisible(true)
    setPatientAppointmentID(appointmentID)
  }
  // const getAppointmentData = async () => {
  //     setIsPageLoading(true)
  //     try {

  //         let data = await SaveExtra('Get_By_Type', 'AppointmentsData', '', '')
  //         data = JSON.parse(data.d)?.Data || [];

  //         if (data) {
  //             data = data?.map((item) => {
  //                 return {
  //                     Id: item.Id,
  //                     Data: JSON.parse(item?.JsonData)
  //                 }
  //             })

  //         }
  //         setAppointmentDataID(data)
  //         setAppointments(data[0]?.Data)
  //         return data[0]?.Data || []
  //     } catch (error) {
  //         console.log(error)
  //     } finally {
  //         setIsPageLoading(false);

  //     }
  // };

  const isManuallyScheduledAppointment = (appointment) => {
    const status = appointment?.data?.Status
    const scheduleBy = appointment?.data?.ScheduleBy
    const type = appointment?.data?.Type
    const isInFacility = appointment?.data?.isInFacility
    const priorAuth = appointment?.data?.otherDetails?.priorAuth?.isRequired

    let priorAuthTime = 0
    if (priorAuth) {
      priorAuthTime = parseInt(appointment?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
    }

    const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
    const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

    return isScheduledOrRescheduled && isManualOrFollowUp
  }

  const getAppointmentData = async () => {
    setIsPageLoading(true)
    try {
      const result = await PatientAppointmentDetails('GETBYPROVIDERID', '', '', loggedUserProvider?.ID, '')

      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '');
      const rawData = JSON.parse(result.d)?.Data || []

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      setAllAppointment(structuredData)

      let flatAppointments = structuredData.flatMap((p) => p.appointmentDetails)
      const AppointmentCount = flatAppointments.filter((item) => isManuallyScheduledAppointment(item))
      // setPatientCount(AppointmentCount.length)
      setAppointments(flatAppointments)
      setLoaderAppointment(flatAppointments)

      return flatAppointments
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const getAppointmentForAutoSchedule = async () => {
    setIsPageLoading(true)
    try {
      const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '')
      const rawData = JSON.parse(result.d)?.Data || []

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.JsonData)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      return structuredData
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const patientDataFn = async () => {
    setIsPageLoading(true)
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      let patient = JSON.parse(patientData.d).Data
      let appointments = await getAppointmentData()
      let schedulePatient = patient?.filter((patient, index) => appointments.find((item) => item.current.Patient.value === patient.PatientID))

      setPatientData(schedulePatient)
      setAppointment(appointments)

      let count = schedulePatient.length
      // setPatientCount(count)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }
  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)

    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data

    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))
    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
  }

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
        parentCompany: getFacilityParentCompany(facility),
      }))
      setFacilities(formattedData)
      setSelectedFacility(formattedData[0])
    } catch (e) {}
  }

  const [modalVisible, setModalVisible] = useState(false)
  const [viewModalVisible, setViewModalVisible] = useState(false)

  const handleonClick = () => {
    setModalVisible((e) => !e)
  }

  const patientSelectedFacility = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) {}
  }

  const saveDiagnosisData = async (customData) => {
    let a = {}
    let facility = await patientSelectedFacility(customData)
    try {
      a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
      a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
      a['Room'] = customData?.Room?.toString() || roomNumber.toString()
    } catch (e) {
      a['FacilityID'] = ''
      a['FacilityName'] = ''
      a['Room'] = -1
    }

    // let allDiagnosis = allSelectedDiagnosis.map(obj => { return obj.label }).join(",");

    let allDiagnosis = customData?.Diagnosis || ''

    let insurances = addedInsurances.map((ins) => ({
      InsuranceID: ins?.ID,
    }))

    let savePatientInfo
    if (patientID && patientID !== '') {
      savePatientInfo = SavePatients('Update', JSON.stringify(customData ? customData : childformData), JSON.stringify(a), allDiagnosis, patientID, JSON.stringify(insurances))
    }

    // await savePatientInfo;

    await patientDataFn()
    // resetStates()
  }

  useEffect(() => {
    getAppointmentData()
    getData()
    patientDataFn()
    getFacilities()
  }, [loggedUserProvider])

  const noteStructureRef = useRef({})

  // if (rowClicked) {
  //   let provideInformation = rowClicked.Diagnosis.split(',');
  //   let information = provideInformation.map((item) => {
  //     return (
  //       { diagnosis: item, information: 'patient' }
  //     )
  //   })

  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     information,
  //   }

  // }

  const handleDeletePatient = async () => {
    let patientData = await SavePatients('Delete', '', '', '', deletePatientID, '')
    await patientDataFn()
    setDeletePatientID(null)
    setDeleteVisible(false)
  }

  const handleClicksPatiens = (patient) => {
    setPatientIDClicked(patient?.PatientID)
    setPatientID(patient?.PatientID)
    setRowClicked(patient)
    setShowPatientInfo(true)
  }
  const [showFilter, setShowFilter] = useState(false)
  const [filterData, setFilterData] = useState({
    facility: [],
    searchValue: '',
    date: '',
    status: [],
  })
  const [filteredPatientData, setFilteredPatientData] = useState([])
  const selectStatusOption = [
    { value: 'NewPatient', label: 'New Patient' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Re Admit', label: 'Re Admit' },
  ]

  const selectedOption = selectStatusOption.find((option) => option.value === filterData.status)

  const getProvidersMaster = async () => {
    setIsPageLoading(true)
    try {
      // Fetch provider data
      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      const getUser = JSON.parse(localStorage.getItem('user'))
      const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      setLoggedUserProvider(foundProvider || {})
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getProvidersMaster()
  }, [])

  // const GetPatientTreatmentsNotes = async () => {
  //     if (!patientData) return;

  //     setIsPageLoading(true)
  //     try {
  //         let updatedPatients = await Promise.all(
  //             patientData.map(async (patient) => {
  //                 let status = patient.noteStatus || "Not Started"; // Default status
  //                 let flag = "false"; // Default flag

  //                 try {
  //                     const dataResponse = await PatientNoteDataCRUD("GET", patient?.PatientID);
  //                     const parsedData = JSON.parse(dataResponse?.d)?.Data;
  //                 const isProviderAppointment = providerName === loggedUserProvider?.Name;

  //                     // if (Array.isArray(parsedData) && parsedData.length > 0) {
  //                     //     status = parsedData[parsedData.length - 1]?.status || status;
  //                     //     flag = parsedData[parsedData.length - 1]?.flag || "false";
  //                     // }
  //                 } catch (err) {
  //                     console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err);
  //                 }
  //                 const patientAppointments = appointment.filter(item => item.current.Patient.value === patient.PatientID);

  //                 // let providerName = provider[0]?.current?.Provider?.label;
  //                 // let scheduleDate = provider[0]?.data?.StartTime
  //                 // scheduleDate = scheduleDate?.split(" ")

  //                 const scheduledAppointment = patientAppointments.find(p => {
  //                     const status = p?.data?.Status;
  //                     const scheduleBy = p?.data?.ScheduleBy;
  //                     const type = p?.data?.Type;
  //                     const isInFacility = p?.data?.isInFacility
  //                     const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
  //                     let priorAuthTime = 0;
  //                     if (priorAuth) {
  //                         priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)

  //                     }

  //                     // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
  //                     const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && (priorAuthTime > 0));
  //                     const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled';

  //                     return isScheduledOrRescheduled && isManualOrFollowUp;
  //                 });

  //                 if (!scheduledAppointment) return null;

  //                 const providerName = scheduledAppointment?.current?.Provider?.label;
  //                 const scheduleDate = scheduledAppointment?.data?.StartTime?.split(" ")[0];
  //                 const Type = scheduledAppointment?.data?.Type

  //                 const isProviderAppointment = providerName === loggedUserProvider?.Name;

  //                 if (!isProviderAppointment) return null;

  //                 return { ...patient, noteStatus: status, noteFlag: flag, scheduleDate };
  //             })
  //         );
  //         // updatedPatients = updatedPatients.filter(item => item.noteStatus === "Submitted")
  //         updatedPatients = updatedPatients.filter(item =>
  //             item?.noteStatus == 'Finished' || (item?.noteFlag == 'true' && item?.noteStatus == 'Signed')
  //             // item => (item?.noteFlag == 'true' && (item?.noteStatus == 'Finished' || )
  //             // item => (item?.noteFlag == 'true' && item?.noteStatus == 'Draft')
  //         );

  //         setFilteredPatientData(updatedPatients);

  //     } catch (error) {
  //         console.error("Error fetching patient orders", error);
  //         // toast.error('Error in patient treatment', toastConfig);
  //     }
  // };

  // const GetPatientTreatmentsNotes = async () => {
  //     if (!patientData) return;

  //     setIsPageLoading(true)
  //     try {
  //         let updatedPatients = await Promise.all(
  //             patientData.map(async (patient) => {
  //                 let isNotePresentForProvider = false
  //                 let isSignedOrFinishedNoteExists = false

  //                 try {
  //                     const dataResponse = await PatientNoteDataCRUD("GET", patient?.PatientID);
  //                     let parsedData = JSON.parse(dataResponse?.d)?.Data;
  //                     // const isProviderAppointment = providerName === loggedUserProvider?.Name;
  //                     isSignedOrFinishedNoteExists = parsedData?.some(item => item?.status === 'Signed' || item.status === 'Finished')
  //                     parsedData.map((item,) => {
  //                         const appointmentDetailsForNote = allAppointment.find(item => item.patientID === patient?.PatientID)
  //                         if (appointmentDetailsForNote?.appointmentDetails?.some(
  //                             appt => appt.data?.ProviderName === loggedUserProvider?.Name
  //                         )) {
  //                             isNotePresentForProvider = true;
  //                         }

  //                         // isNotePresentForProvider = appointmentDetailsForNote?.data?.ProviderName === loggedUserProvider?.Name
  //                         // isNotePresentForProvider = appointmentDetailsForNote?.data?.ProviderName === loggedUserProvider?.Name && (item?.status === 'Signed' || item.status === 'Finished')
  //                         return {
  //                             ...item,
  //                             data: item?.data ? JSON.parse(item?.data) : {},
  //                         }
  //                     })

  //                     return {
  //                         ...patient,
  //                         isNotePresentForProvider,
  //                         isSignedOrFinishedNoteExists,
  //                     }

  //                 } catch (err) {
  //                     console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err);
  //                 }
  //             })
  //         );
  //         // updatedPatients = updatedPatients.filter(item => item.noteStatus === "Submitted")
  //         // updatedPatients = updatedPatients.filter(item =>
  //         //     item?.noteStatus == 'Finished' || (item?.noteFlag == 'true' && item?.noteStatus == 'Signed')
  //         //     // item => (item?.noteFlag == 'true' && (item?.noteStatus == 'Finished' || )
  //         //     // item => (item?.noteFlag == 'true' && item?.noteStatus == 'Draft')
  //         // );
  //         updatedPatients = updatedPatients.filter(item => item.isNotePresentForProvider && item.isSignedOrFinishedNoteExists)

  //         setFilteredPatientData(updatedPatients);

  //     } catch (error) {
  //         console.error("Error fetching patient orders", error);
  //         // toast.error('Error in patient treatment', toastConfig);
  //     }
  // };
  const GetPatientTreatmentsNotes = async () => {
    if (!patientData || !appointment || !loggedUserProvider?.Name) return

    try {
      const updatedPatients = await Promise.all(
        appointment
          .filter((item) => item?.data?.ProviderName === loggedUserProvider?.Name)
          .map(async (appt) => {
            const patient = patientData.find((p) => p.PatientID === appt?.data?.PatientID)

            if (!patient) return

            try {
              const dataResponse = await PatientNoteDataCRUD('GET', patient.PatientID)
              const parsedData = JSON.parse(dataResponse?.d)?.Data || []

              let status = 'Not Created'
              let flag = 'false'

              const noteIdForThisAppointment = appt?.data?.NoteID
              const findNote = parsedData.find((note) => note?.id === noteIdForThisAppointment && note?.status === 'Signed' && note?.flag === 'true')

              if (!(appt?.data?.patientSeen === false || findNote)) {
                return
              }
              if (findNote) {
                status = findNote?.status || status
                flag = findNote?.flag || 'false'
              }

              // if (status === 'Signed') return // Skip signed

              return {
                ...patient,
                ...appt,
                noteStatus: status,
                noteFlag: flag,
                noteIdWhichIsSigned: findNote?.id,
                providerAssigned: appt?.current?.Provider?.label,
                scheduleStartTime: appt?.data?.StartTime,
                appointmentStatus: appt?.data?.Status,
                patientTerm: appt?.data?.term || '',
                ...(typeof appt?.data?.patientSeen === 'boolean' && {
                  patientSeen: appt.data.patientSeen,
                  notSeenReason: appt.data.notSeenReason,
                }),
              }
            } catch (err) {
              console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
            }
          }),
      )

      // Filter out undefined/null results
      setFilteredPatientData(updatedPatients.filter(Boolean))
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      toast.error('Error in patient treatment', toastConfig)
    }
  }

  useEffect(() => {
    GetPatientTreatmentsNotes()
  }, [patientData, loggedUserProvider])

  // Patient Appointments
  const [showPatientAppointmentId, setShowPatientAppointmentId] = useState(null)
  const [patientAppointment, setPatientAppointment] = useState([])
  const [activeKey, setActiveKey] = useState(1)
  const GetSelectedPatientAppoint = async () => {
    try {
      const selectedAppointments = appointment.filter((appoint) => appoint?.data?.PatientID === showPatientAppointmentId)
      setPatientAppointment(selectedAppointments)
    } catch (error) {
      console.error('Error fetching patient appointments:', error)
      toast.error('Error fetching patient appointments', toastConfig)
    }
  }

  // const handleAppointmentSubmit = async () => {
  //     try {
  //         setIsPageLoading(true)
  //         let appointmentFilterData = appointments.filter(item => (item.data.AppointmentID !== appointmentID))
  //         await SaveExtra('Update', 'AppointmentsData', JSON.stringify(appointmentFilterData), appointmentDataID[0]?.Id);
  //          patientDataFn()

  //         if (cancelModel) {
  //             toast.success('Cancel Appointment Successfully', toastConfig)
  //         } else if(finishModel) {
  //             toast.success('Finish Appointment Successfully', toastConfig)
  //         }
  //         // toast.success('Cancel Appointment Successfully', toastConfig)
  //     } catch (error) {
  //         toast.error('Failed to save', toastConfig)
  //     } finally {
  //         setIsPageLoading(false)
  //         setCancelModel(false)
  //         setFinishModel(false)
  //         setAppointmentID(null)
  //     }
  // }

  const handleAppointmentSubmit = async (type, appointmentID, patientId) => {
    try {
      setIsPageLoading(true)
      const ChangeNoteStatus = handlePatientNote('Finished', appointmentID, patientId)
      const groupedData = []
      let appointmentFilterData = appointments.map((item) => {
        if (item.data.AppointmentID === appointmentID) {
          const now = new Date()
          const formattedEndDate = now
            .toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
            .replace(',', '')
          return {
            ...item,
            data: {
              ...item.data,
              Status: type,
              EndTimezone: formattedEndDate,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()
      if (cancelModel) {
        toast.success('Finish Appointment Successfully', toastConfig)
      } else {
        // toast.success('Finish Appointment Successfully', toastConfig)
      }
      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
      setCancelModel(false)
      setFinishModel(false)
      setAppointmentID(null)
    }
  }

  const handleDeleteSubmit = async () => {
    try {
      setIsPageLoading(true)
      const DeleteNote = deletePatientNote(appointmentID, patientId)
      const groupedData = []
      let appointmentFilterData = appointments.filter((item) => item.data.AppointmentID !== appointmentID)

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()
      toast.success('Delete Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
      setDeleteModel(false)
      setAppointmentID(null)
      setPatientID(null)
    }
  }

  const handleAppointmentCancel = async (type) => {
    try {
      setIsPageLoading(true)
      const ChangeNoteStatus = handlePatientNote('Canceled', appointmentID, patientId)
      const groupedData = []
      let appointmentFilterData = appointments.map((item) => {
        if (item.data.AppointmentID === appointmentID) {
          const now = new Date()
          const formattedEndDate = now
            .toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
            .replace(',', '')
          return {
            ...item,
            data: {
              ...item.data,
              Status: type,
              EndTimezone: formattedEndDate,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()
      toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
      setCancelModel(false)
      setFinishModel(false)
      setAppointmentID(null)
    }
  }

  const handleAddNoteId = async (noteID) => {
    try {
      setIsPageLoading(true)

      const groupedData = []
      let appointmentFilterData = appointments.map((item) => {
        if (item.data.AppointmentID === patientAppointmentID) {
          return {
            ...item,
            data: {
              ...item.data,
              NoteID: noteID,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()

      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save Note Id', toastConfig)
    } finally {
      setIsPageLoading(false)
      setPatientAppointment(null)
    }
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const handlePatientNote = async (type, appointmentID, patientId) => {
    try {
      if (!appointmentID || !patientId) {
        throw new Error('Missing appointmentId or patientId.')
      }

      const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)

      if (appointmentFilterData.length === 0) {
        throw new Error(`No appointment found with ID: ${appointmentID}`)
      }

      const noteID = appointmentFilterData[0]?.data?.NoteID

      if (!noteID) {
        throw new Error(`NoteID not found for appointment ID: ${appointmentID}`)
      }

      const dataResponse = await PatientNoteDataCRUD('GET', patientId)

      if (!dataResponse?.d) {
        throw new Error('No data received from PatientNoteDataCRUD GET.')
      }

      const parsedResponse = JSON.parse(dataResponse.d)
      const parsedData = parsedResponse?.Data

      if (!Array.isArray(parsedData)) {
        throw new Error('Parsed patient data is not a valid array.')
      }

      const findNote = parsedData.filter((item) => item.id === noteID)

      if (findNote.length === 0) {
        throw new Error(`No patient note found with ID: ${noteID}`)
      }

      const treatmentData = findNote[0]
      const id = treatmentData?.id

      if (!id) {
        throw new Error('Note ID is missing in the matched note.')
      }

      let data = {}

      try {
        data = treatmentData?.data ? JSON.parse(treatmentData.data) : {}
      } catch (e) {
        console.error('Invalid JSON in treatmentData.data:', e)
        data = {}
      }

      if (type === 'Canceled') {
        data.NoteCancelReason = cancelReason
      }

      await PatientNoteDataCRUD('UPDATE', patientId.toString(), id.toString(), JSON.stringify(data), getFormattedDate().toString(), type, 'true')

      setCancelReason('')
    } catch (err) {
      console.error('Error in handlePatientNote:', err.message || err)
      setCancelReason('')
    }
  }

  const deletePatientNote = async (appointmentID, patientId) => {
    try {
      if (!appointmentID || !patientId) {
        throw new Error('Missing appointmentId or patientId.')
      }

      const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)

      if (appointmentFilterData.length === 0) {
        throw new Error(`No appointment found with ID: ${appointmentID}`)
      }

      const noteID = appointmentFilterData[0]?.data?.NoteID

      if (!noteID) {
        throw new Error(`NoteID not found for appointment ID: ${appointmentID}`)
      }

      const dataResponse = await PatientNoteDataCRUD('GET', patientId)

      if (!dataResponse?.d) {
        throw new Error('No data received from PatientNoteDataCRUD GET.')
      }

      const parsedResponse = JSON.parse(dataResponse.d)
      const parsedData = parsedResponse?.Data

      if (!Array.isArray(parsedData)) {
        throw new Error('Parsed patient data is not a valid array.')
      }

      const findNote = parsedData.filter((item) => item.id === noteID)

      if (findNote.length === 0) {
        throw new Error(`No patient note found with ID: ${noteID}`)
      }

      await PatientNoteDataCRUD('DELETE', patientID.toString(), noteID.toString())
    } catch (err) {
      console.error('Error in patient delete:', err.message || err)
    }
  }

  const getFacilitiesAppointment = async () => {
    let facilities = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(facilities.d)

    facilities = data.Data
    facilities = facilities.filter((obj) => {
      if (obj.Days && obj.Days != '') {
        return obj
      }
    })
    setLocations(facilities)
  }

  function formatDate(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  const handleAppointment = (appointmentID, type, patientId, patient) => {
    if (type === 'cancel') {
      setCancelModel(true)
    } else if (type === 'finish') {
      getSuperBillData(patientId)
      handleAppointmentSubmit('Finish', appointmentID, patientId)
      setTimeout(() => {
        handleAutoSchedule(patient, appointmentID)
      }, 1000)
    } else if (type === 'delete') {
      setDeleteModel(true)
    }

    setAppointmentID(appointmentID)
    setPatientId(patientId)
    setSuperBill([])
  }

  const handleSubmit = async (updateData) => {
    try {
      setIsPageLoading(true)

      const groupedData = []

      updateData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      // getAppointmentData();
      getAppointmentData()
      patientDataFn()
      toast.success('Patient Auto Scheduled  Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to Auto Scheduled', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const getAllProviderDetails = async (obj) => {
    const provider = {
      ID: obj.ID,
    }
    let providerData = await fetchPatientData('SELECTALL', 'Provider', JSON.stringify(provider))
    let insuranceData = JSON.parse(providerData.d)?.Insurance
    let facilityData = JSON.parse(providerData.d)?.Facility
    // setselectProviderInsurances(insuranceData)
    // setselectProviderFacilities(facilityData)

    obj['Insurances'] = insuranceData
    obj['Facilities'] = facilityData

    return obj
  }

  const getProviders = async () => {
    let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
    let data = JSON.parse(providerData.d)
    providerData = data.Data
    let newProviders = []
    for (let i = 0; i < providerData.length; i++) {
      let c = await getAllProviderDetails(providerData[i])
      newProviders.push(c)
    }

    const daysMap = {}

    // Iterate through the providers array
    newProviders.forEach((provider) => {
      // Iterate through each facility of the provider
      provider.Facilities.forEach((facility) => {
        // Split the Days string into an array of days
        const daysArray = facility.Days.split(',')

        // For each day in the daysArray, add the provider to the corresponding entry in the map
        daysArray.forEach((day) => {
          day = day.trim()
          if (!daysMap[day]) {
            daysMap[day] = []
          }

          // Find if the provider already exists in the day's list
          let providerEntry = daysMap[day].find((p) => p.ID === provider.ID)
          if (!providerEntry) {
            // Add the provider if not already in the list for that day
            providerEntry = {
              ID: provider.ID,
              Name: provider.Name,
              Gender: provider.Gender,
              DOB: provider.DOB,
              Address: provider.Address,
              AddressDetails: provider.AddressDetails,
              Lat: provider.Lat,
              Lng: provider.Lng,
              Insurances: provider.Insurances,
              Facilities: [],
            }
            daysMap[day].push(providerEntry)
          }

          // Add the facility to the provider's list of facilities
          providerEntry.Facilities.push(facility)
        })
      })
    })

    setDaysMap(daysMap)
    return newProviders
  }

  const allData = useRef({})

  const handleSchedule = async (props, patient, oldData) => {
    if (!props?.StartTime || !props?.EndTime) return

    let scheduleAppointmentTime = await getSuperBillData(patient.PatientID)
    const weeksMatch = scheduleAppointmentTime?.match(/(\d+)\s*week/i)
    const weeksToAdd = weeksMatch ? parseInt(weeksMatch[1], 10) : 1
    let startTime = new Date(props.StartTime)
    let targetDate = new Date(startTime)
    targetDate.setDate(targetDate.getDate() + weeksToAdd * 7)
    const date = targetDate.toISOString().split('T')[0]
    const dayOptions = { weekday: 'long' }
    const day = targetDate.toLocaleDateString('en-US', dayOptions)

    try {
      const allDayData = daysMap[day]
      if (!allDayData) {
        console.warn(`No data found for ${day}.`)
        alert('No schedule available for this day.')
        return
      }

      allDayData.forEach((obj) => {
        obj.Facilities.forEach((facility) => {
          let tempFacility = locations.find((o) => o.ID == facility.FacilityID)
          facility['Name'] = tempFacility?.Name || ''
          facility['Type'] = tempFacility?.Type || ''
        })
      })

      const providerInfo = allDayData.filter((obj) => obj.Facilities.some((facility) => facility.Name === patient.FacilityName))

      if (providerInfo.length === 0) {
        console.warn(`No provider assigned to ${patient.FacilityName} on ${day}.`)
        alert('No providers are currently assigned to this facility on the selected day.')
        return
      } else {
        let provider = providerInfo.filter((item) => item?.ID === oldData?.current?.Provider?.value)
        if (provider.length === 0) {
          provider = providerInfo[0]
        } else {
          provider = provider[0]
        }
        allData.current.Provider = {
          value: provider?.ID,
          label: provider?.Name,
        }
        return targetDate
      }
    } catch (e) {
      console.error('Error processing schedule:', e)
    }
  }

  const handleAutoSchedule = async (item, appointmentID) => {
    const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
    let patientInsurance = await PatientInsuranceFn('SELECT', '', item.PatientID)
    let tempAppointments = []
    let Insurance = {}
    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
      if (patientInsurance.length > 0) {
        Insurance = JSON.parse(patientInsurance[0].InsuranceDetails)
        Insurance = Insurance[0] || {}
      }
    } catch (e) {}
    try {
      let getPatientTime = await PatientNoteDataCRUD('GET', item.PatientID)
      getPatientTime = JSON.parse(getPatientTime.d)?.Data
      getPatientTime = getPatientTime.map((entry) => ({
        ...entry,
        getPatientTime: entry.getPatientTime ? JSON.parse(entry.getPatientTime) : {},
      }))
      if (getPatientTime) {
        let rawDate = getPatientTime.length > 0 ? getPatientTime[0].date : new Date().toISOString().split('T')[0]
        let formattedDate = rawDate.replaceAll('.', '/')

        let props = {
          StartTime: appointmentFilterData.length > 0 ? appointmentFilterData[0]?.data.StartTime : formattedDate,
          EndTime: formattedDate,
          PatientID: item.PatientID,
        }

        let filtered = await getAppointmentForAutoSchedule()

        let oldData
        if (filtered.length > 0) {
          filtered = filtered.filter((entry) => entry.patientID === item.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Signed' || appt.data?.Status === 'Finish'))
          oldData = filtered[0].appointmentDetails.at(-1)
        }

        if (oldData?.data?.isInFacility === false) {
          alert(`Patient ${item.FirstName} ${item.LastName || ''} is not in the facility and cannot be scheduled.`)
          return
        }
        let updateOtherDetails = {}

        const priorAuth = oldData?.data?.otherDetails?.priorAuth
        if (priorAuth?.isRequired) {
          let noOfTimes = parseInt(priorAuth?.details?.noOfTimes, 10)

          if (isNaN(noOfTimes) || noOfTimes <= 0) {
            alert(`Patient ${item.FirstName} ${item.LastName || ''} has no remaining insurance and cannot be scheduled.`)
            if (oldData?.data) {
              oldData.data.isInFacility = false
            }
            return
          } else {
            updateOtherDetails = {
              ...oldData.data.otherDetails,
              priorAuth: {
                ...priorAuth,
                details: {
                  ...priorAuth.details,
                  noOfTimes: `${noOfTimes - 1}`,
                },
              },
            }
          }
        }

        let scheduledDate = await handleSchedule(props, item, oldData)
        let organizeDate = formatDate(scheduledDate)

        let facility = locations?.find((facility) => facility.Name === item.FacilityName)

        let localPatient = { value: item.PatientID, label: `${item.FirstName} ${item.LastName}` }
        let localFacility = { value: facility?.ID, label: facility?.Name }
        let localProvider = allData.current?.Provider || {}

        let data = {
          AppointmentName: `${item.FirstName} ${item.LastName}`,
          StartTime: organizeDate,
          EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
          PatientID: item.PatientID,
          StartTimezone: null,
          EndTimezone: null,
          Facility: facility?.Name || '',
          Insurance: Insurance || {},
          Status: 'Scheduled',
          Notes: '',
          RoomNumber: item.Room,
          RecurrenceRule: '',
          VisitReason: 'F/U (Follow Up)',
          isInFacility: oldData ? oldData?.data?.isInFacility || true : true,
          otherDetails: oldData ? updateOtherDetails || {} : {},
          AppointmentID: Date.now(),
          ProviderName: localProvider?.label || '',
          ScheduleBy: 'auto-manuel',
          // PatientStatus: filtered.length > 0 ? 'Follow Up' :  item?.Status || 'NewPatient'
          Type: 'Follow Up',
          CreatedDate: new Date(),
          // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
        }

        let details = {
          data,
          current: {
            Patient: localPatient,
            Facility: localFacility,
            Provider: localProvider,
            Insurance: Insurance,
          },
        }

        tempAppointments.push(details)
      } else {
        alert('Patient creation failed: Patient creation date not found. \n Hint: Try using manual-schedule to proceed.')
      }
    } catch (error) {
      console.error('Error fetching patient orders', error)
    }
    // Update appointments once at the end
    if (tempAppointments.length > 0) {
      setAppointments((prev) => {
        const allAppointments = [...prev, ...tempAppointments]
        handleSubmit(allAppointments)
        return allAppointments
      })
    }
  }

  useEffect(() => {
    if (showPatientAppointmentId) {
      GetSelectedPatientAppoint()
    }
  }, [showPatientAppointmentId])

  useEffect(() => {
    getProviders()
    getFacilitiesAppointment()
  }, [])

  const getSuperBillData = async (patientID) => {
    try {
      let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientID.toString())
      data = JSON.parse(data?.d)?.Data || []

      if (data?.length) {
        data = data.map((item) => ({
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }))
      }

      setSuperBill(data)

      const lastItem = data?.at(-1)?.Data?.followUpTime ?? null

      setScheduleTime(lastItem)
      return lastItem
    } catch (error) {
      console.error('Error fetching Super Bill data:', error)
    }
  }

  const getIntoNoteLatestHandle = async (patientID, patientData) => {
    const patientAppointments = appointment.filter((item) => item.current.Patient.value === patientData?.PatientID)
    const scheduledAppointment = patientAppointments.find((p) => {
      const status = p?.data?.Status
      const scheduleBy = p?.data?.ScheduleBy
      const type = p?.data?.Type
      const isInFacility = p?.data?.isInFacility
      const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
      let priorAuthTime = 0
      if (priorAuth) {
        priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
      }

      // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
      const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
      const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

      return isScheduledOrRescheduled && isManualOrFollowUp
    })
    const dataResponse = await PatientNoteDataCRUD('GET', patientID)
    const parsedData = JSON.parse(dataResponse?.d)?.Data
    if (parsedData?.length > 0 && patientAppointments?.length > 0) {
      setPatientID(patientData?.PatientID)
      setPatientIDClicked(patientData?.PatientID)
      setRowClicked(patientData)
      setPatientModalVisible(true)
      setPatientAppointmentID(scheduledAppointment?.data?.AppointmentID)
      const latestItem = parsedData[parsedData.length - 1]
      // setEditDataId(latestItem?.id);
      setDataCallType('edit')
      setNoteStatus(`parsedData.length` - 1 === 0 ? 'New Note' : 'Follow Up')
      setPatientModalVisible(false)
      setNoteID(parsedData.length - 1)
      setPatientData(patientData)
      noteStructureRef.current = JSON.parse(latestItem?.data)
      setAllPatientVisible(true)
      setNodeId(latestItem?.id)
      setNoteIndex(index)
    }
  }

  const [groupedUpdatedFilteredPatients, setGroupedUpdatedFilteredPatients] = useState({})
  const [updatedFilteredPatients, setUpdatedFilteredPatients] = useState([])

  const fetchPatientDataFiltedAndGrouped = async () => {
    const updatedFilteredPatients =
      filteredPatientData &&
      filteredPatientData
        .map((patient) => ({
          ...patient,
          facilityParentCompany: getPatientFacilityParentCompany(patient, facilities),
        }))
        .filter((patient) => {
          const selectedFacilityLabels = facilities.filter((facility) => filterData.facility.includes(facility.value)).map((facility) => facility.label)

          const matchesFacility = filterData.facility.length === 0 || selectedFacilityLabels.includes(patient.FacilityName)

          const matchesStatus = filterData.status.length === 0 || filterData.status.includes(patient.Status)

          const matchesSearchValue =
            !filterData.searchValue ||
            patientMatchesSearch(patient, filterData.searchValue, {
              facilityName: patient?.FacilityName,
              facilityParentCompany: patient?.facilityParentCompany,
            })

          const matchesDate = !filterData.date || patient?.DOB === filterData.date

          return matchesFacility && matchesStatus && matchesSearchValue && matchesDate
        })
        .filter(Boolean)

    const groupedByFacilityDate = {}
    updatedFilteredPatients.forEach((patient) => {
      const date = patient?.scheduleStartTime.split?.(' ')?.[0]
      const facility = patient.FacilityName

      if (!groupedByFacilityDate[date]) {
        groupedByFacilityDate[date] = {}
      }

      if (!groupedByFacilityDate[date][facility]) {
        groupedByFacilityDate[date][facility] = []
      }

      groupedByFacilityDate[date][facility].push(patient)
    })

    // updatedFilteredPatients.forEach((patient) => {
    //     const facility = patient.FacilityName;

    //     if (!groupedByFacility[facility]) {
    //         groupedByFacility[facility] = [];
    //     }

    //     groupedByFacility[facility].push(patient);
    // });

    setGroupedUpdatedFilteredPatients(groupedByFacilityDate)

    setUpdatedFilteredPatients(updatedFilteredPatients)
    setPatientCount(updatedFilteredPatients?.length)
    setPatientInfoCount({
      followUp: updatedFilteredPatients.filter((item) => item?.Status === 'Follow Up').length,
      newPatient: updatedFilteredPatients.filter((item) => item?.Status === 'NewPatient').length,
    })
    setIsPageLoading(false)
  }

  useEffect(() => {
    fetchPatientDataFiltedAndGrouped()
  }, [filterData, filteredPatientData, facilities])
  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role
  const [appointmentTestData, setAppointmentTestData] = useState(null)
  const hasFetchedData = useRef(false)
  const getDataforAppointmentTest = async (logId) => {
    const appointmentDetails = await getAllAppointmentsDetails('GETBYPROVIDERID', '', logId)
    return appointmentDetails
  }

  useEffect(() => {
    if (loggedUserProvider?.ID && !hasFetchedData.current) {
      const fetchData = async () => {
        const data = await getDataforAppointmentTest(loggedUserProvider?.ID)

        setAppointmentTestData(data)
        hasFetchedData.current = true
      }

      fetchData()
    }
  }, [loggedUserProvider?.ID])

  const [selectedPatientId, setSelectedPatientId] = useState(null)

  const [masterModel, setMasterModel] = useState(null)
  const { checkIfMastersExist } = useIndexedDB()

  const checkData = async () => {
    const hasData = await checkIfMastersExist()
    if (!hasData) {
      setMasterModel(true)
    }
  }

  useEffect(() => {
    checkData()
  }, [])

  return (
    <div>
      {showPatientInfo ? (
        <PatientProviderPatientInfo
          isAllotedToProvider={true}
          creatingNewNote={creatingNewNote}
          setCreatingNewNote={setCreatingNewNote}
          childformData={childformData}
          setChildFormData={setChildFormData}
          saveDiagnosisData={saveDiagnosisData}
          noteStatus={noteStatus}
          patientID={patientIDClicked}
          patientData={rowClicked}
          noteStructureRef={noteStructureRef}
          dataCallType={dataCallType}
          setEditDataId={setEditDataId}
          setDataCallType={setDataCallType}
          noteID={noteID}
          setDataId={setDataId}
          handleAddNoteId={handleAddNoteId}
          appointments={appointments}
        />
      ) : setDataId ? (
        <PatientProviderPatientInfo
          isAllotedToProvider={true}
          creatingNewNote={creatingNewNote}
          setCreatingNewNote={setCreatingNewNote}
          childformData={childformData}
          setChildFormData={setChildFormData}
          saveDiagnosisData={saveDiagnosisData}
          noteStatus={noteStatus}
          patientID={patientIDClicked}
          patientData={rowClicked}
          noteStructureRef={noteStructureRef}
          dataCallType={dataCallType}
          setDataId={setDataId}
          setDataCallType={setDataCallType}
          noteID={noteID}
          setEditDataId={setEditDataId}
          handleAddNoteId={handleAddNoteId}
          appointments={appointments}
        />
      ) : (
        <div className=" position-relative">
          <div className="patient-page-wrapper page-wrapper">
            <div className="page-header mb-3">
              <div className="d-flex align-items-center gap-2 dark-search">
                <div className={` search-input ${role == 'provider' ? 'search-dark' : ''}`}>
                  <SearchIcon />
                  <input
                    className="input-field-provider-page"
                    onChange={(e) => {
                      setFilterData({ ...filterData, searchValue: e.target.value })
                    }}
                    type="text"
                    placeholder="Search by Patient Name..."
                  />
                </div>
                <div className="position-relative ">
                  <Button
                    style={{
                      backgroundColor: '#4363F2',
                      border: '1px solid #333',
                      height: '40px',
                      padding: '5px 14px',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      color: '#fff',
                      fontWeight: '500',
                      fontSize: '14px',
                      boxShadow: 'none',
                    }}
                    className="d-flex align-items-center gap-2 patient-theme-filter-button"
                    variant="outlined"
                    size="large"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <FunnelPlotOutlined />
                    Filter
                  </Button>

                  {showFilter && (
                    <motion.div
                      initial={{ opacity: 0, y: 4 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 4 }}
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                      style={{
                        width: '300px',
                        zIndex: 50,
                        backgroundColor: '#282828',
                        borderRadius: '10px',
                      }}
                      className="position-absolute gap-1 d-flex flex-column top-full left-0 z-10   shadow-lg p-4 rounded-md"
                    >
                      <div>
                        <CFormLabel>Facility</CFormLabel>
                        <Select
                          placeholder="Select"
                          name="facility"
                          options={facilities}
                          value={facilities.filter((fac) => filterData.facility.includes(fac.value))}
                          isMulti
                          isClearable
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: '#191919',
                              borderColor: state.isFocused ? '#444' : '#444',
                              borderRadius: '6px',
                              boxShadow: 'none',
                              '&:hover': {
                                borderColor: '#444',
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              backgroundColor: '#000',
                              borderRadius: '6px',
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? '#191919' // blue for selected
                                : state.isFocused
                                ? '#2a2a2a'
                                : '#000',
                              color: 'white',
                              cursor: 'pointer',
                              padding: '12px 14px',
                              borderBottom: '1px solid #333',
                              ':last-of-type': {
                                borderBottom: 'none',
                              },
                              ':active': {
                                backgroundColor: '#2a2a2a',
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: '#191919',
                              borderRadius: '4px',
                              border: '1px solid #454545ff',
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: 'white',
                              ':hover': {
                                backgroundColor: '#333',
                                color: 'white',
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#aaa',
                            }),

                            input: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: 'white',
                              ':hover': { color: 'white' },
                            }),
                          }}
                          onChange={(selectedOptions) =>
                            setFilterData((prev) => ({
                              ...prev,
                              facility: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                            }))
                          }
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </div>

                      <div className="mt-2">
                        <CFormLabel>Patient Status</CFormLabel>
                        <Select
                          name="status"
                          isMulti
                          placeholder="Select"
                          options={selectStatusOption}
                          isClearable
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: '#191919',
                              borderColor: state.isFocused ? '#444' : '#444',
                              borderRadius: '6px',
                              boxShadow: 'none',
                              '&:hover': {
                                borderColor: '#444',
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              backgroundColor: '#000',
                              borderRadius: '6px',
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? '#191919' // blue for selected
                                : state.isFocused
                                ? '#2a2a2a'
                                : '#000',
                              color: 'white',
                              cursor: 'pointer',
                              padding: '12px 14px',
                              borderBottom: '1px solid #333',
                              ':last-of-type': {
                                borderBottom: 'none',
                              },
                              ':active': {
                                backgroundColor: '#2a2a2a',
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: '#191919',
                              borderRadius: '4px',
                              border: '1px solid #454545ff',
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: 'white',
                              ':hover': {
                                backgroundColor: '#333',
                                color: 'white',
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#aaa',
                            }),

                            input: (base) => ({
                              ...base,
                              color: 'white',
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: 'white',
                              ':hover': { color: 'white' },
                            }),
                          }}
                          value={selectStatusOption.filter((option) => filterData.status.includes(option.value))}
                          onChange={(selectedOptions) =>
                            setFilterData((prev) => ({
                              ...prev,
                              status: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                            }))
                          }
                          classNamePrefix="select"
                        />
                      </div>

                      <div className="mt-2" style={{ position: 'relative', display: 'inline-block' }}>
                        <CFormLabel>DOB</CFormLabel>

                        <div>
                          <CustomDatePickingFormat
                            type="date"
                            color="primary"
                            value={filterData.date || ''}
                            aria-describedby="exampleFormControlInputHelpInline"
                            onChange={(e) => {
                              setFilterData((p) => ({
                                ...p,
                                date: e, // Keep the date in "YYYY-MM-DD" format
                              }))
                            }}
                          />
                        </div>
                        {/* <CFormInput
                                                            type="date"
                                                            color="primary"
                                                            value={filterData.date || ""}
                                                            aria-describedby="exampleFormControlInputHelpInline"
                                                            onChange={(e) => {
                                                                setFilterData((p) => ({
                                                                    ...p,
                                                                    date: e.target.value // Keep the date in "YYYY-MM-DD" format
                                                                }));
                                                            }}
                                                        /> */}
                      </div>

                      <Button
                        style={{
                          backgroundColor: '#4363F2',
                          border: '1px solid #333',
                          height: '40px',
                          padding: '5px 14px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px',
                          color: '#fff',
                          fontWeight: '500',
                          fontSize: '14px',
                          boxShadow: 'none',
                        }}
                        className="mt-2"
                        onClick={() => setShowFilter(false)}
                        variant="outlined"
                      >
                        Close
                      </Button>
                    </motion.div>
                  )}
                </div>
              </div>
              <div className="d-flex align-items-center">
                {/* <div className="display-total-patient mx-4"><span className="mx-1">{patientCount}</span> Patients</div> */}
                {/* <Button variant="contained" onClick={handleonClick}>+ Add Patient</Button> */}
                <div className="d-flex align-items-center gap-2">
                  <div className="display-total-patient">
                    <span className="mx-1">{patientInfoCount?.newPatient || 0}</span> NP
                  </div>
                  <div className="display-total-patient">
                    <span className="mx-1">{patientInfoCount?.followUp || 0}</span> FU
                  </div>
                  <div className="display-total-patient">
                    <span className="mx-1">{patientCount}</span> Patients
                  </div>
                  {/* <Button variant="contained" onClick={handleonClick}>+ Add Patient</Button> */}
                  <div className="d-flex align-items-center justify-content-end gap-1 mx-2 ">
                    {/* <CButton
                      onClick={() => {
                        setBoxView('list')
                      }}
                      style={{
                        backgroundColor: boxView === 'list' ? '#4363F2' : '#0E0E0E',
                        border: '1px solid #333',
                        height: '40px',
                        padding: '5px 14px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '14px',
                        boxShadow: 'none',
                      }}
                      color={boxView === 'list' ? 'primary' : 'light'}
                      className=" d-flex align-items-center justify-content-center"
                    >
                      <Table2 size={16} strokeWidth={1.25} />
                      <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>List</div>
                    </CButton> */}
                    {/* <CButton
                      onClick={() => {
                        setBoxView('table')
                      }}
                      style={{
                        backgroundColor: boxView === 'table' ? '#4363F2' : '#0E0E0E',
                        border: '1px solid #333',
                        height: '40px',
                        padding: '5px 14px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: '14px',
                        boxShadow: 'none',
                      }}
                      disabled
                      color={boxView === 'table' ? 'primary' : 'light'}
                      className="  d-flex align-items-center justify-content-center"
                    >
                      <AlignLeft size={16} strokeWidth={1.25} />
                      <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>Details</div>
                    </CButton> */}
                  </div>
                </div>
              </div>
            </div>

            {boxView === 'table' && (
              <div className="custom-card-wrapper">
                {updatedFilteredPatients.length > 0 &&
                  updatedFilteredPatients.map((patient, index) => {
                    // let provider = appointment.filter(item => item.current.Patient.value === patient.PatientID);
                    const patientAppointments = appointment.filter((item) => item.current.Patient.value === patient.PatientID)

                    // let providerName = provider[0]?.current?.Provider?.label;
                    // let scheduleDate = provider[0]?.data?.StartTime
                    // scheduleDate = scheduleDate?.split(" ")

                    const scheduledAppointment = patientAppointments.find((p) => {
                      const status = p?.data?.Status
                      const scheduleBy = p?.data?.ScheduleBy
                      const type = p?.data?.Type
                      const isInFacility = p?.data?.isInFacility
                      const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
                      let priorAuthTime = 0
                      if (priorAuth) {
                        priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
                      }

                      // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
                      const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
                      const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

                      return isScheduledOrRescheduled && isManualOrFollowUp
                    })

                    if (!scheduledAppointment) return null

                    const providerName = scheduledAppointment?.current?.Provider?.label
                    const scheduleDate = scheduledAppointment?.data?.StartTime?.split(' ')[0]
                    const Type = scheduledAppointment?.data?.Type

                    const isProviderAppointment = providerName === loggedUserProvider?.Name

                    if (!isProviderAppointment) return null
                    return (
                      <div key={index} className="custom-card">
                        <div className="card-header">
                          <div>
                            <div className="d-flex align-items-center gap-2">
                              <p className="name-block">
                                {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                                <span
                                  style={{
                                    color: Type === 'New' ? 'green' : Type === 'Follow Up' ? 'orange' : 'skyblue',
                                    fontWeight: 'bold',
                                    fontSize: '0.6em',
                                  }}
                                >
                                  ({Type === 'Follow Up' ? 'Follow Up' : Type === 'New' ? 'New Patient' : Type === 'Re Admit' ? 'Re Admit' : ''})
                                </span>
                              </p>
                            </div>
                            <div className="bullet-points">
                              <span>{patient.Gender}</span>
                              <span>
                                DOB:{' '}
                                {new Date(patient?.DOB).toLocaleDateString('en-US', {
                                  month: '2-digit',
                                  day: '2-digit',
                                  year: 'numeric',
                                })}
                              </span>
                              <span>{patient.Age} Years</span>
                            </div>
                          </div>
                          <div className="button-wrapper">
                            <CButton onClick={() => openTreatmentNote(patient, scheduledAppointment?.data?.AppointmentID)} variant="outline" color="dark" className="px-2">
                              <ExitToAppIcon size={20} />
                            </CButton>
                            {/* <a href="/home/scheduler"><CButton variant='outline' color='warning' className="px-2"><HiPencil size={20} /></CButton></a>
                                                        <CButton onClick={() => setShowPatientAppointmentId(patient?.PatientID)} variant='outline' color='success' className="px-2"><HiEye size={20} /></CButton>
                                                        <CDropdown>
                                                            <CDropdownToggle
                                                                style={{
                                                                    padding: 0,
                                                                    margin: 0
                                                                }}
                                                                color="">
                                                                <CButton variant='outline' color='dark' className="calendar-button px-2"><CalendarCheck size={20} /></CButton>
                                                            </CDropdownToggle>
                                                            <CDropdownMenu>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'cancel', patient?.PatientID, patient)}>Cancel</CDropdownItem>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'finish', patient?.PatientID, patient)}>Finish</CDropdownItem>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'delete', patient?.PatientID, patient)}>Delete</CDropdownItem>

                                                            </CDropdownMenu>
                                                        </CDropdown> */}
                            {/* <CButton onClick={() => {
                                                                // setPatientData(patient)
                                                                getIntoNoteLatestHandle(patient?.PatientID, patient)
                                                            }} variant='outline' color="success" className="px-2"><Eye size={20} /></CButton> */}
                          </div>
                        </div>
                        <div className="contact-wrapper w-100  d-flex  px-3">
                          <div>
                            <p className="title">Provider Name</p>
                            <p className="value">{providerName}</p>
                          </div>
                          <div>
                            <p className="title">Schedule Date</p>
                            <p className="value">{scheduleDate}</p>
                          </div>
                          {/* <div>
                                                        <p className="title">Note Status</p>
                                                        <p className="value">{patient.noteStatus || ""}</p>
                                                    </div> */}
                        </div>
                        <div className="card-footer w-100 d-flex justify-content- align-items-start">
                          <div className="facility mw-100">
                            <p className="title">FACILITY NAME</p>
                            <p className="value">
                              {patient.FacilityName}
                              {patient.facilityParentCompany && ` - ${patient.facilityParentCompany}`}
                            </p>
                          </div>
                          <div className="room-count">
                            <p className="title">ROOM</p>
                            <p className="value">{patient.Room ?? ''}</p>
                          </div>
                        </div>
                      </div>
                    )
                  })}
              </div>
            )}

            {boxView === 'list' && (
              <div className="hide-drag-table">
                <div className="mt-3">
                  <CAccordion alwaysOpen className="border-bottom-0  m-0 w-100 border-0 p-0" style={{ borderRadius: '10px' }}>
                    {groupedUpdatedFilteredPatients &&
                      Object.keys(groupedUpdatedFilteredPatients).length > 0 &&
                      Object.entries(groupedUpdatedFilteredPatients).map(([date, facilities], dateIdx) => {
                        const totalPatients = Object.values(facilities).reduce((acc, patients) => acc + patients.length, 0)

                        return (
                          <div className="testdiv mb-2 provider-page">
                            <div className="border-bottom-0 border-0" itemKey={`date-${dateIdx}`} key={date}>
                              <div className="border-bottom-0 border-0 mb-2">
                                {date} ({totalPatients})
                              </div>

                              <div className={`accordion-wrapper border-bottom-0 border-0 p-0 shadow-sm ${role == 'provider' ? 'accordion-dark' : 'accordion-light'}`} style={{ borderRadius: '40px!important' }}>
                                <CAccordion alwaysOpen className="border-bottom-0   m-0 w-100 border-0 p-0 homeAccordion">
                                  {Object.entries(facilities).map(([facility, patients], facIdx) => {
                                    const parentCompanyName = patients.find((patient) => patient?.facilityParentCompany)?.facilityParentCompany || ''

                                    return (
                                      <CAccordionItem className="border-bottom-0 border-0 mt-2">
                                        <CAccordionHeader className="border-bottom-0 border-0 px-3 py-1 m-0 my-2  " style={{ fontSize: '14px', boxShadow: 'unset' }}>
                                          <div className="d-flex align-items-center gap-2 flex-wrap w-100">
                                            <span>
                                              {facility} - ({patients.length} Patient{patients.length > 1 ? 's' : ''}) {parentCompanyName && `- ${parentCompanyName}`}
                                            </span>
                                          </div>
                                        </CAccordionHeader>

                                        <CAccordionBody className="mx-3 p-0 bg-transparent-linear">
                                          <CTable responsive className=" mb-3 border-bottom-0 border-0">
                                            <CTableBody>
                                              {patients
                                                .sort((a, b) => {
                                                  const aAppt = appointment.find((item) => item.current.Patient.value === a.PatientID)
                                                  const bAppt = appointment.find((item) => item.current.Patient.value === b.PatientID)

                                                  const aSeen = aAppt?.data?.patientSeen === false
                                                  const bSeen = bAppt?.data?.patientSeen === false

                                                  if (aSeen && !bSeen) return 1
                                                  if (!aSeen && bSeen) return -1
                                                  return 0
                                                })
                                                .map((patient) => {
                                                  const patientAppointments = appointment.filter((item) => item.current.Patient.value === patient.PatientID)

                                                  // let providerName = provider[0]?.current?.Provider?.label;
                                                  // let scheduleDate = provider[0]?.data?.StartTime
                                                  // scheduleDate = scheduleDate?.split(" ")

                                                  const scheduledAppointment = patientAppointments.find((p) => {
                                                    const status = p?.data?.Status
                                                    const scheduleBy = p?.data?.ScheduleBy
                                                    const type = p?.data?.Type
                                                    const isInFacility = p?.data?.isInFacility
                                                    const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
                                                    let priorAuthTime = 0
                                                    if (priorAuth) {
                                                      priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
                                                    }
                                                    // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
                                                    const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
                                                    const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled' || status === 'Signed'

                                                    return isScheduledOrRescheduled
                                                  })

                                                  // if (!scheduledAppointment) return null

                                                  const providerName = scheduledAppointment?.current?.Provider?.label
                                                  const scheduleDate = scheduledAppointment?.data?.StartTime?.split(' ')[0]
                                                  const Type = scheduledAppointment?.data?.Type

                                                  const isProviderAppointment = providerName === loggedUserProvider?.Name

                                                  if (!isProviderAppointment) return null

                                                  return (
                                                    <CTableRow
                                                      className="order-0 patient-row-shadow"
                                                      key={patient.PatientID}
                                                      // onClick={() => {
                                                      //    openTreatmentNote(patient, scheduledAppointment?.data?.AppointmentID)
                                                      //    setShowNoteJustThisId(patient?.noteIdWhichIsSigned)
                                                      // }}
                                                      onClick={() => {
                                                        setSelectedPatientId(patient.PatientID)
                                                        openTreatmentNote(patient, scheduledAppointment?.data?.AppointmentID)
                                                        setShowNoteJustThisId(patient?.noteIdWhichIsSigned)

                                                        setTimeout(() => {
                                                          setSelectedPatientId(null)
                                                        }, 10000)
                                                      }}
                                                      style={{
                                                        cursor: 'pointer',
                                                        verticalAlign: 'middle',
                                                        gap: '20px',
                                                        margin: '10px 2px',
                                                        background: '#1E1E1E',
                                                        boxShadow: selectedPatientId === patient.PatientID ? '0 0 10px #ffffff' : '0 0 4px rgba(0, 0, 0, 0.5)',
                                                        borderRadius: '6px',
                                                        transition: 'all 0.25s ease-in-out',
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        if (selectedPatientId !== patient.PatientID) {
                                                          e.currentTarget.style.boxShadow = '0 0 8px rgba(255,255,255,0.2)'
                                                        }
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        if (selectedPatientId !== patient.PatientID) {
                                                          e.currentTarget.style.boxShadow = '0 0 4px rgba(0, 0, 0, 0.5)'
                                                        }
                                                      }}
                                                    >
                                                      <CTableDataCell className="border-bottom-0 border-0" scope="row">
                                                        <span className="patient-name-fixed text-white">{patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}</span>
                                                      </CTableDataCell>

                                                      <CTableDataCell className="d-flex justify-content-end align-items-center border-bottom-0 border-0">
                                                        <span className="room-pill"> Room: {patient?.Room}</span>
                                                        {patient?.patientSeen === false && <span className="schedule1-pill">Not Seen : {patient?.notSeenReason}</span>}
                                                        {/* <span className='notestatus-pill'>Note Status: {patient?.noteStatus === 'Draft' && patient?.noteFlag === 'true' ? "Provider Draft" : patient?.noteStatus}</span>
                                                                                                    <span className='schedule-pill'>Scheduled Date: {scheduleDate}</span> */}
                                                        {/* You can add action buttons here if needed */}
                                                        <div className="card-header   border-0 mb-0 gap-2">
                                                          {/* <CButton onClick={() => {
                                                                                                            // setPatientData(patient)
                                                                                                            getIntoNoteLatestHandle(patient?.PatientID, patient)
                                                                                                        }} variant='outline' color="success" className="px-2"><Eye size={20} /></CButton> */}
                                                          {/* <CButton
                                                        onClick={() => {
                                                          openTreatmentNote(patient, scheduledAppointment?.data?.AppointmentID)
                                                          setShowNoteJustThisId(patient?.noteIdWhichIsSigned)
                                                        }}
                                                        variant="outline"
                                                        color="dark"
                                                        className="p-1 border-white"
                                                      >
                                                        <ExitToAppIcon style={{ color: 'white' }} size={15} />
                                                      </CButton> */}
                                                        </div>
                                                      </CTableDataCell>
                                                    </CTableRow>
                                                  )
                                                })}
                                            </CTableBody>
                                          </CTable>
                                        </CAccordionBody>
                                      </CAccordionItem>
                                    )
                                  })}
                                </CAccordion>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    {groupedUpdatedFilteredPatients && Object.keys(groupedUpdatedFilteredPatients).length === 0 && (
                      <div className="d-flex justify-content-center align-items-center text-muted">
                        <div
                          style={{
                            fontSize: '15px',
                            fontWeight: '600px',
                            color: 'gray',
                          }}
                        >
                          No Appointments Available
                        </div>
                      </div>
                    )}
                  </CAccordion>
                </div>

                {/* <CustomAgGrid callFrom="Patient" toggleFilter={toggleAgGrid} rowClickedFn={patientSelected} options={filteredPatientData} btnList={buttonList}></CustomAgGrid> */}
              </div>
            )}

            <CModal size="lg" visible={patientModelVisible} onClose={() => setPatientModalVisible(false)}>
              {/* patientData, patientID, setPatientModalVisible, setDataCallType, setShowPatientInfo, setEditDataId, setNoteID, patientSelected, childformData, setChildFormData, saveDiagnosisData */}
              <CModalBody className="view-data-modal" style={{ padding: '2rem', overflow: 'auto', background: '#282828' }}>
                {
                  <ProviderPatientPoupSignedChart
                    showNoteJustThisId={showNoteJustThisId}
                    patientModelVisible={patientModelVisible}
                    breadCrumbHref="/home/provider/completed-appointment"
                    breadCrumbText="Completed Appointments"
                    creatingNewNote={creatingNewNote}
                    setCreatingNewNote={setCreatingNewNote}
                    noteStatus={noteStatus}
                    setNoteStatus={setNoteStatus}
                    patientSelected={patientSelected}
                    setNoteID={setNoteID}
                    childformData={childformData}
                    setChildFormData={setChildFormData}
                    saveDiagnosisData={saveDiagnosisData}
                    patientID={patientIDClicked}
                    patientData={rowClicked}
                    noteStructureRef={noteStructureRef}
                    setPatientModalVisible={setPatientModalVisible}
                    dataCallType={dataCallType}
                    setDataCallType={setDataCallType}
                    setEditDataId={setEditDataId}
                    setShowPatientInfo={setShowPatientInfo}
                    setAllSelectedDiagnosis={setAllSelectedDiagnosis}
                    patientAppointmentID={patientAppointmentID}
                    appointment={appointment}
                    viewPatientDetail={viewPatientDetail}
                    handleAddNoteId={handleAddNoteId}
                    showViewIcon={true}
                  />
                }
              </CModalBody>
              <CModalFooter
                style={{
                  backgroundColor: '#282828',
                  borderTop: '1px solid gray',
                  paddingTop: '10px',
                }}
              >
                <Button
                  style={{
                    backgroundColor: '#4363F2',
                    border: '1px solid #333',
                    height: '40px',
                    padding: '5px 14px',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    color: '#fff',
                    fontWeight: '500',
                    fontSize: '14px',
                    boxShadow: 'none',
                  }}
                  variant="outlined"
                  onClick={() => setPatientModalVisible(false)}
                >
                  Close
                </Button>
              </CModalFooter>
            </CModal>

            <CModal visible={deleteVisible} onClose={() => setDeleteVisible(false)}>
              <CModalHeader>
                <CModalTitle>Warning</CModalTitle>
              </CModalHeader>
              <CModalBody>
                <p>Are you sure you want to delete?</p>
              </CModalBody>

              <CModalFooter>
                <CButton
                  onClick={() => {
                    setDeleteVisible(false)
                  }}
                  className="text-white"
                  color="secondary"
                >
                  Close
                </CButton>
                <CButton onClick={handleDeletePatient} className="text-white" color="danger">
                  Delete
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal
              className="rounded"
              alignment="center"
              onClose={() => {
                setShowPatientAppointmentId(null)
              }}
              visible={showPatientAppointmentId !== null}
              aria-labelledby="VerticallyCenteredExample"
            >
              <CModalHeader>
                <CModalTitle className="" style={{ fontSize: '20px!important' }} id="VerticallyCenteredExample">
                  Appointment Details
                </CModalTitle>
              </CModalHeader>
              <CModalBody className="w-100">
                <CNav className="d-flex align-items-center justify-content-center w-100" variant="pills" role="tablist">
                  <CNavItem>
                    <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)}>
                      Insurances
                    </CNavLink>
                  </CNavItem>
                  <CNavItem className="">
                    <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)}>
                      Other Details
                    </CNavLink>
                  </CNavItem>
                </CNav>
                <CTabContent>
                  <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeKey === 1}>
                    <div style={{ widht: '100%!important' }} className="d-flex py-2 w-100 align-items-center gap-4 justify-content-between flex-wrap w-full">
                      {patientAppointment.length > 0 ? (
                        <div>
                          {patientAppointment
                            .filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')
                            .map((item, idx) => {
                              return (
                                <div key={idx} className="w-100">
                                  <div
                                    style={{
                                      display: 'grid!important',
                                      gridTemplateColumns: '1fr 1fr 1fr',
                                      gridGap: '10px',
                                    }}
                                    className="w-100"
                                  >
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Prior Auth Number: </p>
                                      <p className="fw-light">{item?.data?.otherDetails?.priorAuth?.details?.priorAuthNo ?? ''}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Number of times: </p>
                                      <p className="fw-light">{item?.data?.otherDetails?.priorAuth?.details?.noOfTimes ?? ''}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Expiry Date: </p>
                                      <p className="fw-light">{item?.data?.otherDetails?.priorAuth?.details?.expDate ?? ''}</p>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                      ) : (
                        <div>
                          <div className="w-100">
                            <div
                              style={{
                                display: 'grid!important',
                                gridTemplateColumns: '1fr 1fr 1fr',
                                gridGap: '10px',
                              }}
                              className="w-100"
                            >
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Prior Auth Number: </p>
                                <p className="fw-light">{''}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Number of times: </p>
                                <p className="fw-light">{''}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Expiry Date: </p>
                                <p className="fw-light">{''}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </CTabPane>
                  <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeKey === 2}>
                    <div style={{ widht: '100%!important' }} className="d-flex py-2 w-100 align-items-center gap-4 justify-content-between flex-wrap w-full">
                      {patientAppointment.length > 0 ? (
                        <div>
                          {patientAppointment
                            .filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')
                            .map((item, idx) => {
                              return (
                                <div key={idx} className="w-100">
                                  <div
                                    style={{
                                      display: 'grid!important',
                                      gridTemplateColumns: '1fr 1fr 1fr',
                                      gridGap: '10px',
                                    }}
                                    className="w-100"
                                  >
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Insurance Type</p>
                                      <p className="fw-light">{item?.data?.Insurance?.Type ?? ''}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Insurance Sub Type</p>
                                      <p className="fw-light">{item?.data?.Insurance?.SubType ?? ''}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <p className="title fw-bold">Policy Number: </p>
                                      <p className="fw-light">{item?.data?.Insurance?.PolicyNumber ?? ''}</p>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                      ) : (
                        <div>
                          <div className="w-100">
                            <div
                              style={{
                                display: 'grid!important',
                                gridTemplateColumns: '1fr 1fr 1fr',
                                gridGap: '10px',
                              }}
                              className="w-100"
                            >
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Policy Number: </p>
                                <p className="fw-light">{''}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Insurance Type</p>
                                <p className="fw-light">{''}</p>
                              </div>
                              <div className="d-flex gap-2">
                                <p className="title fw-bold">Insurance Sub Type</p>
                                <p className="fw-light">{''}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </CTabPane>
                </CTabContent>
              </CModalBody>
            </CModal>

            <CModal visible={cancelModel} onClose={() => setCancelModel(false)}>
              <CModalHeader>
                <CModalTitle>Cancel Appointment</CModalTitle>
              </CModalHeader>

              <CModalBody>
                <div className="mt-4 p-4 rounded-4 shadow-sm border position-relative" style={{ backgroundColor: '#f8f9fa', borderLeft: '5px solid #dc3545' }}>
                  <div className="d-flex align-items-center mb-3">
                    <h6 className="mb-0 fw-bold text-dark">Cancellation Reason </h6>
                  </div>

                  <CFormTextarea
                    id="cancelReason"
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                    placeholder="Type your cancellation reason here..."
                    className="rounded-3 shadow-sm border-0"
                    style={{
                      height: '140px',
                      padding: '1rem',
                      fontSize: '1rem',
                      backgroundColor: '#ffffff',
                      // resize: 'none',
                    }}
                  />
                </div>
              </CModalBody>

              <CModalFooter>
                <CButton onClick={() => setCancelModel(false)} className="text-white" color="secondary">
                  Close
                </CButton>
                <CButton onClick={() => handleAppointmentCancel('Canceled')} className="text-white" color="danger">
                  Proceed to Cancel
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal visible={finishModel} onClose={() => setFinishModel(false)}>
              <CModalHeader>
                <CModalTitle>Finish Appointment</CModalTitle>
              </CModalHeader>
              <CModalBody>
                <p>Are you sure you want to finish this appointment?</p>
              </CModalBody>

              <CModalFooter>
                <CButton
                  onClick={() => {
                    setFinishModel(false)
                  }}
                  className="text-white"
                  color="secondary"
                >
                  Close
                </CButton>
                <CButton
                  onClick={() => {
                    handleAppointmentSubmit('Finish')
                  }}
                  className="text-white"
                  color="success"
                >
                  Finish Appointment
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal visible={deleteModel} onClose={() => setDeleteModel(false)}>
              <CModalHeader>
                <CModalTitle>Delete Appointment</CModalTitle>
              </CModalHeader>
              <CModalBody>
                <p>Are you sure you want to Delete this appointment?</p>
              </CModalBody>

              <CModalFooter>
                <CButton
                  color="secondary"
                  variant="outline"
                  onClick={() => {
                    setDeleteModel(false)
                  }}
                >
                  Cancel
                </CButton>
                <CButton
                  color="danger"
                  className="hrm-modal-danger-btn"
                  onClick={() => {
                    handleDeleteSubmit()
                  }}
                >
                  Delete
                </CButton>
              </CModalFooter>
            </CModal>
          </div>

          {/* <Pageloader isLoading={isPageLoading} /> */}
          {appointmentTestData == null ? (
            <Pageloader isLoading={true} />
          ) : appointmentTestData.length > 0 && filteredPatientData.length > 0 ? (
            <Pageloader isLoading={isPageLoading} />
          ) : (
            // <Pageloader isLoading={(!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0)  } />
            <div style={{ color: 'gray', display: 'flex', justifyContent: 'center ', marginTop: '200px' }}> </div>
          )}
          {/* <Pageloader isLoading={(!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0) && filteredPatientData.length === 0  } /> */}
        </div>
      )}

      <CModal
        size="lg"
        visible={allPatientVisible}
        onClose={() => {
          setAllPatientVisible(false), setShowNotePatient(false), setNodeId(null), setNoteIndex(null)
        }}
      >
        <CModalHeader>
          <CModalTitle>Note</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div style={{ height: '45vw', overflow: 'auto' }}>
            <PatientInfo patientID={patientData.PatientID} patientData={patientData} dataCallType="edit" noteID={noteID} setDataId={setDataId} showAllData={false} showNoteView={true} appointments={appointment} />
          </div>
        </CModalBody>

        <CModalFooter>
          <CButton
            onClick={() => {
              setAllPatientVisible(false)
              setShowNotePatient(false)
              setNodeId(null)
              setNoteIndex(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal visible={masterModel} onClose={() => setMasterModel(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#191919',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Download Master</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            backgroundColor: '#191919',
            color: 'white',
          }}
        >
          <p>Please download master before continuing .</p>
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#191919',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton
            onClick={() => {
              setMasterModel(false)
            }}
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            variant="outline"
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}
export default CompletedProviderAppointment
